import { render, staticRenderFns } from "./ModalTermAndCondition.vue?vue&type=template&id=89c4528c&scoped=true&"
import script from "./ModalTermAndCondition.vue?vue&type=script&lang=js&"
export * from "./ModalTermAndCondition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89c4528c",
  null
  
)

export default component.exports